module.exports = __webpack_public_path__ + "img/home_employee.c39730e7.jpg";